import {
  EmployeeAttendanceReportApiProps,
  EmployeeAttendanceReportResponse,
  EmployeeLateComingsReportApiProps,
} from '../../../../types/TimeAndAttendance/AttendanceReport/attendanceReportTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import {
  AllowedHttpMethods,
  employeeAttendanceReportApiConfig,
} from '../../apiList'

const getEmployeeAttendanceReport = async (
  props: EmployeeAttendanceReportApiProps,
): Promise<EmployeeAttendanceReportResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeAttendanceReportApiConfig.getEmployeeAttendance,
    method: AllowedHttpMethods.get,
    params: {
      employeeId: props.employeeId,
      month: props.month ?? 0,
      year: props.year ?? 0,
      startIndex: props.startIndex ?? 0,
      endIndex: props.endIndex ?? 20,
      status: props.status ?? 'Active',
      shiftid: props.shiftId ?? '',
      search: props.search ?? '',
      country: props?.country ?? '',
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const exportAttendanceReport = async (
  props: EmployeeAttendanceReportApiProps,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeAttendanceReportApiConfig.exportAttendance,
    method: AllowedHttpMethods.get,
    params: {
      employeeId: props.employeeId,
      month: props.month ?? 0,
      year: props.year ?? 0,
      status: props.status ?? 'Active',
      shiftid: props.shiftId ?? '',
      search: props.search ?? '',
      token: localStorage.getItem('token') ?? '',
      tenantKey: localStorage.getItem('tenantKey') ?? '',
      country: props?.country ?? '',
    },
    responseType: 'blob',
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const exportBiometricAttendanceReport = async (
  props: EmployeeAttendanceReportApiProps,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeAttendanceReportApiConfig.exportBiometricAttendance,
    method: AllowedHttpMethods.get,
    params: {
      employeeId: props.employeeId,
      month: props.month ?? 0,
      year: props.year ?? 0,
      status: props.status ?? 'Active',
      shiftid: props.shiftId ?? '',
      search: props.search ?? '',
      token: localStorage.getItem('token') ?? '',
      tenantKey: localStorage.getItem('tenantKey') ?? '',
      country: props?.country ?? '',
    },
    responseType: 'blob',
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const searchAttendance = async (
  props: EmployeeAttendanceReportApiProps,
): Promise<EmployeeAttendanceReportResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeAttendanceReportApiConfig.searchAttendance,
    method: AllowedHttpMethods.get,
    params: {
      employeeId: props.employeeId,
      month: props.month ?? 0,
      year: props.year ?? 0,
      startIndex: props.startIndex ?? 0,
      endIndex: props.endIndex ?? 20,
      status: props.status ?? 'Active',
      shiftid: props.shiftId ?? '',
      search: props.search ?? '',
      country: props?.country ?? '',
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const exportLateComingsReport = async (
  props: EmployeeLateComingsReportApiProps,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeAttendanceReportApiConfig.exportLateComingsReport,
    method: AllowedHttpMethods.get,
    params: {
      month: props?.month,
      year: props?.year,
      status: props?.status,
      shiftid: props?.shiftid,
      country: props?.country,
      employeeId: props?.employeeId,
    },
    responseType: 'blob',
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const attendanceReportApi = {
  getEmployeeAttendanceReport,
  exportAttendanceReport,
  exportBiometricAttendanceReport,
  searchAttendance,
  exportLateComingsReport,
}
export default attendanceReportApi
